import { getChangeLogData } from '../../services/changelog.service';
import { GET_CHANGELOG_DATA, PUSH_CHANGELOG_DATA } from './changelogType';

export const fetchChangeLog = () => async (dispatch, getState) => {
  const skip = getState()?.changelog?.list?.length || 0;
  const response = await getChangeLogData(skip);
  if (response?.status) {
    dispatch({
      type: GET_CHANGELOG_DATA,
      payload: response.data,
    });
  }
};

export const setChangeLogData = (data) => async (dispatch) => {
  dispatch({
    type: PUSH_CHANGELOG_DATA,
    payload: data,
  });
};
